// src/guide/tickets/guide_tickets.js
import {
  guide_tour_init,
  guide_tour_step,
  guide_tour_step_complete,
} from "@/guide/utils/guide_tour_actions";

export async function guide_tickets(langs) {
  let translations;
  try {
    // Charge dynamiquement le JSON correspondant (ex: guide_traduction_fr.json)
    translations = (
      await import(`@/guide/traductions/guide_traduction_${langs}.json`)
    ).default;
  } catch (error) {
    console.error(
      "Erreur lors du chargement des traductions pour la langue",
      langs,
      error
    );
    return;
  }
  const tour = guide_tour_init();

  tour.addStep({
    title: translations.tickets.barreNavigation.titre,
    text: translations.tickets.barreNavigation.texte,
    attachTo: {
      element: `#${(document.getElementById(
        "barreNavigation_tickets_0_header_action"
      ).parentElement.parentElement.id = "barraNavigation_ticket")}`,
      on: "",
    },
    canClickTarget: false,
    buttons: [
      {
        action() {
          document
            .getElementById("barreNavigation_tickets_0_header_action")
            .click();
          setTimeout(() => {
            tour.next();
          }, 20);
        },
        text: translations.boutons.suivant,
      },
    ],
  });

  guide_tour_step(
    tour,
    translations,
    translations.tickets.caracteristiques_liste_tickets.titre,
    translations.tickets.caracteristiques_liste_tickets.texte,
    "#caracteristiques_liste_tickets",
    "bottom"
  );

  guide_tour_step_complete(
    tour,
    translations,
    translations.tickets.nouveau_ticket.titre,
    translations.tickets.nouveau_ticket.texte,
    "#ajouter_nouveau_ticket",
    "top"
  );

  tour.start();
}
